import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { BehaviorSubject, from, take } from 'rxjs';
import { WeekDay } from 'src/app/api/contracts/menu';
import { Order, OrderType } from 'src/app/api/contracts/order';
import { ModalService } from 'src/app/services/modal.service';
import { OrderService } from 'src/app/services/order.service';
import { LoaderController } from 'src/app/utils/loader-controller';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
  private readonly orderId: string;

  public readonly order$ = new BehaviorSubject<Order | null>(null);
  public readonly loader = new LoaderController();
  public readonly orderTypes = OrderType;

  constructor(
    private readonly navCtrl: NavController,
    private readonly route: ActivatedRoute,
    private readonly orderService: OrderService,
    private readonly modalService: ModalService
  ) {
    this.orderId = this.route.snapshot.params['id'] as string;
  }

  ngOnInit() {
    this.loadOrder();
  }

  onBackButtonClick(): void {
    from(this.navCtrl.pop()) // pop() already makes back navigation
      .pipe(take(1))
      .subscribe((hasHistory) => {
        if (!hasHistory) {
          this.navCtrl.navigateRoot('/store');
        }
      });
  }

  getOrderDeliveryDays(order: Order): WeekDay[] {
    return Array.from(new Set(order.items.map((item) => item.day)));
  }

  onDownload(): void {}

  private loadOrder() {
    this.loader.enqueue();
    this.orderService.retrieveOrder(this.orderId!).subscribe({
      next: (order) => {
        this.loader.dequeue();
        this.order$.next(order);
      },
      error: (err) => {
        this.loader.dequeue();
      },
    });
  }
}
